// extracted by mini-css-extract-plugin
export default {"root":"space_root__96a89","placeHolderShimmer":"space_placeHolderShimmer__Bo6Zw"};